import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { getCMSObject, TeleScript, IfMobile } from 'sg-ui-components';

import { mapStateToProps, mapDispatchToProps } from '../../Store';

const ScannerTemplate = ({ ticket = { success: false }, actions, buttonText }) => {
    // const initialState = { ticket1_1_1: '' };
    const telescript = getCMSObject('data.components.teleScripts.scanner.jsonBlock');

    // const [formState, setFormState] = useState(initialState);
    const [disabled, setDisabled] = useState(false);

    useEffect(() => {
        clearIfSuccess();
    }, [ticket]);

    // if the form submit was a success, we clear the form
    const clearIfSuccess = async () => {
        if (ticket.success) {
            // actions.drawTicketActions.reset();
            window.open('post_claim');
        }
    };

    const scanCallback = async (infoObject) => {
        let sub1 = infoObject.format.toUpperCase();
        let resultLength = infoObject.result.length;
        console.log('finished scan: ', infoObject);

        if (sub1 != 'UNDEFINED' && infoObject.result != null && infoObject.result != '') {
            if (resultLength < 35) {
                console.log('less than 35');
                await actions.drawTicketActions.enterDrawTicket({
                    ticket1_1_1: infoObject.result,
                });
            } else if (resultLength > 35) {
                console.log('more than 35');

                let webCodeBarCodeStringArray = infoObject.result.split('w');
                let webCodeBarCode = webCodeBarCodeStringArray[1];

                console.log(webCodeBarCode);
                if (webCodeBarCode.length === 25) {
                    await actions.drawTicketActions.enterDrawTicket({
                        ticket1_1_1: webCodeBarCode,
                    });
                } else {
                    console.warn('Request Failed. Web code does NOT contain > 35 characters');
                }
            } else {
                console.warn('invalid barcode.');
            }
        }
    };

    // fire the submission
    const handleSubmit = async (event) => {
        setDisabled(true);
        event.preventDefault();

        console.log('scanning');
        // window.MdiNativeShell =
        //     typeof window.MdiNativeShell === 'undefined'
        //         ? (function (barcode) {
        //               return {
        //                   scanBarcode: function (fn) {
        //                       fn({ format: 'DATA_MATRIX', result: barcode });
        //                   },
        //               };
        //           })('441002530000484294186417153002')
        //         : window.MdiNativeShell;

        const mdiIsNativeShell = () => {
            // an array (true) or null (false) is returned and cast to boolean
            return !!window.navigator.userAgent.match(/(Mdi Native Shell)/);
        };

        if (mdiIsNativeShell()) {
            await window.MdiNativeShell.scanBarcode(scanCallback);
        } else {
            console.warn('No scanner');
        }

        setDisabled(false);
    };

    return (
        <IfMobile>
            <button disabled={disabled} onClick={handleSubmit} type='button' className='btn theme-btn btn-primary scan-btn link-back-btn my-2 w-100'>
                {buttonText ?? <TeleScript line={telescript?.scannerButton}>Scan Ticket</TeleScript>}
            </button>
        </IfMobile>
    );
};

const Scanner = connect(mapStateToProps, mapDispatchToProps)(ScannerTemplate);

export default Scanner;
